var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-list-item', {
    attrs: {
      "to": "/item/".concat(_vm.id)
    }
  }, [_c('v-list-item-avatar', {
    attrs: {
      "size": 48
    }
  }, [_c('v-img', {
    attrs: {
      "src": _vm.$asset.itemicon.format(_vm.item.m_ID) + '.jpg'
    }
  })], 1), _c('v-list-item-content', [_c('v-list-item-subtitle', [_vm._v(_vm._s(_vm.$name(_vm.item.m_Name)))])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }